"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4540],{

/***/ 22303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ make; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./src/utils/MutationObserverHook.ts

var defaultOptions = {
    attributes: true,
    childList: true,
    subtree: true
};
var useMutationObserver = function(targetRef, cb) {
    var config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
    var ref = (0,react.useState)(null), observer = ref[0], setObserver = ref[1];
    (0,react.useEffect)(function() {
        var obs = new MutationObserver(cb);
        setObserver(obs);
    }, [
        cb,
        config,
        setObserver
    ]);
    (0,react.useEffect)(function() {
        if (!observer || !targetRef.current) return;
        observer.observe(targetRef.current, config);
        return function() {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [
        observer,
        targetRef,
        config
    ]);
};

// EXTERNAL MODULE: ./src/hooks/useSmartLink.tsx
var useSmartLink = __webpack_require__(12427);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/TrustpilotWidgetSection.tsx











var Styles = {
    section: function(top_distance, bottom_distance, hidden) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:", hidden ? "none" : "block", ";margin-top:", top_distance ? "".concat(top_distance, "px") : "0.75rem", ";margin-bottom:", bottom_distance ? "".concat(bottom_distance, "px") : "2.5rem", ";");
    },
    header: function(aligment) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", colors["default"].gray[800], ";text-align:", aligment, ";font-weight:600;@media ", Theme_Responsive_bs/* desktop */.gv, "{margin-bottom:2rem;}@media ", Theme_Responsive_bs/* tabletOrMobile */.k$, "{margin-bottom:1.875rem;}");
    },
    h2: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:40px;line-height:50px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:40px;}"),
    h3: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:36px;line-height:46px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:42px;}"),
    h4: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:32px;line-height:42px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:28px;line-height:38px;}")
};
var headerElements = {
    h2: "h2",
    h3: "h3",
    h4: "h4"
};
var TrustpilotWidgetSection = function(param) {
    var block = param.block;
    var title_text = block.title_text, title_alignment = block.title_alignment, title_heading = block.title_heading, widget_code = block.widget_code, smartLink = block.smartLink;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var widgetRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), isHidden = ref[0], setHidden = ref[1];
    var headerTag = headerElements[title_heading] ? headerElements[title_heading] : "h2";
    var Heading = headerTag;
    var onMutationChange = (0,react.useCallback)(function(mutation, observer) {
        if (widgetRef.current && widgetRef.current.querySelector("iframe")) {
            setHidden(false);
            observer.disconnect();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (widgetRef.current && widgetRef.current.querySelector("iframe")) {
            setHidden(false);
        } else if (widgetRef.current && window.Trustpilot) {
            window.Trustpilot.loadFromElement(widgetRef.current.querySelector("div"));
            setHidden(false);
        }
    }, []);
    useMutationObserver(widgetRef, onMutationChange);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                type: "text/javascript",
                src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                async: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "".concat(IndexStyles_bs/* section */.qi, " ").concat(Styles.section(block.top_distance, block.bottom_distance, isHidden))
            }, spotlightProps), {
                children: [
                    title_text !== "" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Heading, {
                        className: "".concat(Styles[title_heading], " ").concat(Styles.header(title_alignment)),
                        children: title_text
                    }) : null,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        ref: widgetRef,
                        dangerouslySetInnerHTML: {
                            __html: widget_code
                        }
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ var components_TrustpilotWidgetSection = (TrustpilotWidgetSection);

;// CONCATENATED MODULE: ./src/components/TrustpilotWidgetSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = components_TrustpilotWidgetSection;
 /* make Not a pure module */ 


/***/ }),

/***/ 90906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Styles, KontentContextConsumer, RichText, Link, IconCard, Heading, BodyText, SimpleIcon */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20859);
/* harmony import */ var bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90289);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92592);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34442);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96533);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72721);
/* harmony import */ var _prezzee_ribbon_src_components_common_IconCard_IconCard_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53871);
/* harmony import */ var _pages_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_components_common_SimpleIcon_SimpleIcon_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94830);
/* harmony import */ var _prezzee_ribbon_src_components_common_IconCard_IconCard_Heading_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37204);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_common_IconCard_IconCard_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86957);
// Generated by ReScript, PLEASE EDIT WITH CARE
















var iconLink = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textDecoration */ .QXS("none"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy({
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var mediumIcon = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2.5)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2.5)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .largeScreen */ .M6, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(3.5)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(3.5)),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var largeIcon = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$("auto"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(5.0)),
        tl: /* [] */ 0
    }
});
function contentWrapper(textAlignment, flexAligment) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("column"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$(flexAligment),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textAlign */ .ydu(textAlignment),
                    tl: /* [] */ 0
                }
            }
        }
    });
}
var Styles = {
    iconLink: iconLink,
    mediumIcon: mediumIcon,
    largeIcon: largeIcon,
    contentWrapper: contentWrapper
};
function CardBuilder(props) {
    var themeType = props.themeType;
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(props.iconCards, function(idx, card) {
        var smartLink = card.smartLink;
        var contentAlignment = card.contentAlignment;
        var icon = card.icon;
        var background_colour = card.background_colour;
        var text_colour = card.text_colour;
        var url = card.url;
        var key = String(idx);
        var displayIcon;
        if (icon !== undefined) {
            var height = icon.height;
            var width = icon.width;
            var url$1 = icon.url;
            var description = icon.description;
            switch(card.iconSize){
                case "large":
                    displayIcon = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                        src: url$1,
                        alt: description,
                        width: width,
                        height: height,
                        className: largeIcon
                    });
                    break;
                case "medium":
                    displayIcon = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                        src: url$1,
                        alt: description,
                        width: width,
                        height: height,
                        className: mediumIcon
                    });
                    break;
                default:
                    displayIcon = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_SimpleIcon_SimpleIcon_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: url$1,
                            alt: description,
                            width: width,
                            height: height
                        })
                    });
            }
        } else {
            displayIcon = null;
        }
        var textStyle = text_colour === "" ? "" : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("p", {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafe */ .K47("color", text_colour + "!important"),
                tl: /* [] */ 0
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("h1, h2, h3, h4, h5, h6", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafe */ .K47("color", card.title_colour + "!important"),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        });
        var bgStyle = background_colour === "" ? "" : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafe */ .K47("backgroundColor", background_colour + "!important"),
            tl: /* [] */ 0
        });
        var cardStyle = rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .make */ .S([
            textStyle,
            bgStyle
        ]);
        var aligmentStyle;
        switch(contentAlignment){
            case "center":
                aligmentStyle = "center";
                break;
            case "left":
                aligmentStyle = "left";
                break;
            default:
                aligmentStyle = "left";
        }
        var flexAligment;
        switch(contentAlignment){
            case "center":
                flexAligment = "center";
                break;
            case "left":
                flexAligment = "flexStart";
                break;
            default:
                flexAligment = "flexStart";
        }
        var iconCardElement = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_IconCard_IconCard_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_pages_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Consumer.make */ .$.make, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("div", {
                        children: [
                            displayIcon,
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_IconCard_IconCard_Heading_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                                children: card.title,
                                themeType: themeType
                            }),
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_IconCard_IconCard_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_8__.make, {
                                    children: card.description
                                }),
                                themeType: themeType
                            })
                        ],
                        className: contentWrapper(aligmentStyle, flexAligment)
                    })
                }),
                itemId: smartLink.itemId,
                elementCodename: smartLink.codename
            }),
            themeType: themeType,
            className: cardStyle
        }, key);
        if (url === "") {
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                children: iconCardElement,
                className: iconLink
            }, key);
        } else if (card.open_in_new_window) {
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
                children: iconCardElement,
                className: iconLink,
                href: url,
                target: "_blank"
            }, key);
        } else {
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: url,
                prefetch: false,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
                    children: iconCardElement,
                    className: iconLink,
                    target: "_self"
                })
            }, key);
        }
    });
}
var KontentContextConsumer;
var RichText;
var Link$1;
var IconCard;
var Heading;
var BodyText;
var SimpleIcon;
var make = CardBuilder;
 /* iconLink Not a pure module */ 


/***/ }),

/***/ 78621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports ImageContainer, HeroImage, TextContainer, Heading, BodyText, CtaLine, CtaLineVideo, KontentContextConsumer, SectionHeading, Styles, VideoModal */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(20859);
/* harmony import */ var bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90289);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34442);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(96533);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(25400);
/* harmony import */ var _pages_index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Modal_Modal_bs_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(50952);
/* harmony import */ var _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51741);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10573);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72721);
/* harmony import */ var _pages_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Modal_Modal_Close_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78804);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70138);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Modal_Modal_Trigger_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20946);
/* harmony import */ var _prezzee_ribbon_src_components_common_SectionHeading_SectionHeading_bs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(12387);
/* harmony import */ var _prezzee_ribbon_src_components_common_TextTransition_TextTransition_bs_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(75184);
/* harmony import */ var _prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81343);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Modal_Modal_Container_bs_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(95157);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_InjectableRichText_bs_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(49507);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(99956);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(64797);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_Image_bs_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(24460);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(58978);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_Heading_bs_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(52096);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(12497);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_CtaLineVideo_bs_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(18330);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_TextContainer_bs_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(21225);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_ImageContainer_bs_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(7742);
/* harmony import */ var _prezzee_ribbon_src_components_business_SectionHeading_SectionHeading_Theme_Business_bs_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(85795);
/* harmony import */ var _prezzee_ribbon_src_components_business_FullWidthHero_FullWidthHero_CtaLineVideo_Theme_Business_bs_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(89627);
// Generated by ReScript, PLEASE EDIT WITH CARE







































var CtaLineVideo = _prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_CtaLineVideo_bs_js__WEBPACK_IMPORTED_MODULE_28__/* .Component */ .w(_prezzee_ribbon_src_components_business_FullWidthHero_FullWidthHero_CtaLineVideo_Theme_Business_bs_js__WEBPACK_IMPORTED_MODULE_32__/* .Theme */ .Q);
var SectionHeading = _prezzee_ribbon_src_components_common_SectionHeading_SectionHeading_bs_js__WEBPACK_IMPORTED_MODULE_16__/* .Component */ .w(_prezzee_ribbon_src_components_business_SectionHeading_SectionHeading_Theme_Business_bs_js__WEBPACK_IMPORTED_MODULE_31__/* .Theme */ .Q);
var container = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(-67)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .belowLargeScreen */ .Qo, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(74))),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                tl: /* [] */ 0
            }
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .mobile */ .ai, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(20))),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0))),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var imageContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .desktop */ .gv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        tl: /* [] */ 0
    }),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .smallScreenOrMobile */ .HH, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("img", {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8("auto"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("absolute"),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$v("zero"),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .IaC("zero"),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }),
            tl: /* [] */ 0
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .mediaRange */ .ae(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .smallScreenBreakpoint */ .j9, _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .tabletBreakpoint */ .ub), {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("img", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2z(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(-30)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .mediaRange */ .ae(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .tabletBreakpoint */ .ub, _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .largeScreenBreakpoint */ .Rf), {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("img", {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2z(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(-25)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var textContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(1300))),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1.875))),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1.875))),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .mediaRange */ .ae(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .tabletBreakpoint */ .ub, _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .largeScreenBreakpoint */ .Rf), {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy({
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(480))),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .smallScreen */ .xC, {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy({
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))),
                            tl: /* [] */ 0
                        }),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(50))),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .mobile */ .ai, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(70))),
                            tl: /* [] */ 0
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var bodyText = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(512))),
    tl: /* [] */ 0
});
var Styles = {
    container: container,
    imageContainer: imageContainer,
    textContainer: textContainer,
    bodyText: bodyText
};
function LandingPage__FullWidthHero$VideoModal(props) {
    var match = react__WEBPACK_IMPORTED_MODULE_2__.useState(function() {
        return false;
    });
    var setModalOpen = match[1];
    var onRequestClose = function onRequestClose(param) {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__._1(setModalOpen, function(param) {
            return false;
        });
    };
    var openFunc = function openFunc(param) {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__._1(setModalOpen, function(param) {
            return true;
        });
    };
    var playerOptions = _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Player.options */ .J.options(undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined);
    var content = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_22__/* .make */ .S, {
            videoUrl: props.url,
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_23__/* .make */ .Sy, {
                id: "video-modal-story",
                playerOptions: playerOptions
            })
        })
    });
    var iconImage = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_34__/* .mapWithDefault */ .k7(props.icon, null, function(param) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height
        });
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_Modal_Modal_bs_js__WEBPACK_IMPORTED_MODULE_35__.make, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Modal_Modal_Trigger_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
                    children: [
                        iconImage,
                        props.text
                    ]
                }),
                openFunc: openFunc
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_Modal_Modal_Container_bs_js__WEBPACK_IMPORTED_MODULE_19__.make, {
                id: "modal-container",
                isOpen: match[0],
                onRequestClose: onRequestClose,
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Modal_Modal_Close_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .S, {
                        closeFunc: onRequestClose
                    }),
                    content
                ],
                borderless: true
            })
        ]
    });
}
var VideoModal = {
    make: LandingPage__FullWidthHero$VideoModal
};
function LandingPage__FullWidthHero(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var video_button_url = block.video_button_url;
    var scrolling_text = block.scrolling_text;
    var title = block.title;
    var bgDesktop = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_34__/* .mapWithDefault */ .k7(block.desktop_image, undefined, function(param) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_36__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .tabletOrMobile */ .k$ + " 388px, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .largeScreen */ .M6 + " 631px, 497px",
            loading: "eager"
        }));
    });
    var bgTablet = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_34__/* .mapWithDefault */ .k7(block.tablet_image, undefined, function(param) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_36__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            sizes: "100vw",
            loading: "eager"
        }));
    });
    var bgMobile = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_34__/* .mapWithDefault */ .k7(block.mobile_image, undefined, function(param) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_36__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            sizes: "100vw",
            loading: "eager"
        }));
    });
    var bgImages = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_18__/* .make */ .S, {
        desktop: bgDesktop,
        smallScreen: bgDesktop,
        tablet: bgTablet,
        mobile: bgMobile
    });
    var bgColourStyle = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_34__/* .mapWithDefault */ .k7(block.background_colour, "", function(bg) {
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_33__._1(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafe */ .K47("backgroundColor", bg),
            tl: /* [] */ 0
        });
    });
    var content;
    if (scrolling_text !== undefined) {
        var textArr = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_37__/* .map */ .UI(scrolling_text.items, function(c) {
            return c.text;
        });
        var injectItem_1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_TextTransition_TextTransition_bs_js__WEBPACK_IMPORTED_MODULE_17__/* .make */ .S, {
            textArr: textArr,
            inline: true,
            noOverflow: true
        });
        var injectItem = [
            "strong",
            injectItem_1
        ];
        var injectArr = [
            injectItem
        ];
        content = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_InjectableRichText_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .make */ .S, {
            children: title,
            injectArr: injectArr
        });
    } else {
        content = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_12__.make, {
            children: title
        });
    }
    var heading = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_Heading_bs_js__WEBPACK_IMPORTED_MODULE_26__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(SectionHeading.make, {
            children: content
        })
    });
    var bodyText$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_27__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_12__.make, {
            children: block.description
        }),
        className: bodyText
    });
    var ctaButtons = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_37__/* .mapWithIndex */ .Su(block.buttons, function(i, b) {
        var target = b.open_in_new_window ? "_blank" : "";
        var match = b.smartLink;
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_pages_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_9__.make, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            href: b.cta_url,
                            prefetch: false,
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("a", {
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("button", {
                                    children: b.cta_text
                                }),
                                target: target
                            })
                        }),
                        fill: b.fill,
                        colour: b.colour,
                        variant: b.variant
                    }, String(i))
                })
            }),
            itemId: match.itemId,
            elementCodename: match.codename
        }, String(i));
    });
    var ctaLine = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_25__/* .make */ .S, {
        children: ctaButtons
    });
    var ctaLineVideo = video_button_url === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(CtaLineVideo.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(LandingPage__FullWidthHero$VideoModal, {
            text: block.video_button_text,
            icon: block.video_button_icon,
            url: video_button_url
        })
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .Sy, {
        classname: classnames__WEBPACK_IMPORTED_MODULE_5___default()([
            container,
            bgColourStyle
        ]),
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_TextContainer_bs_js__WEBPACK_IMPORTED_MODULE_29__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_pages_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .S, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .Consumer.make */ .$.make, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("div", {
                            children: [
                                heading,
                                bodyText$1,
                                ctaLine,
                                ctaLineVideo
                            ]
                        })
                    }),
                    itemId: smartLink.itemId,
                    elementCodename: smartLink.codename
                }),
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_38__/* .make */ .S([
                    _pages_index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .section */ .qi,
                    textContainer
                ])
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_ImageContainer_bs_js__WEBPACK_IMPORTED_MODULE_30__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_common_FullWidthHero_FullWidthHero_Image_bs_js__WEBPACK_IMPORTED_MODULE_24__/* .make */ .S, {
                    children: bgImages,
                    className: imageContainer
                })
            })
        ]
    });
}
var ImageContainer;
var HeroImage;
var TextContainer;
var Heading;
var BodyText;
var CtaLine;
var KontentContextConsumer;
var make = LandingPage__FullWidthHero;
 /* CtaLineVideo Not a pure module */ 


/***/ }),

/***/ 3336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Link, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92592);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34442);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25400);
/* harmony import */ var _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72721);
/* harmony import */ var _index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17845);
/* harmony import */ var _prezzee_ribbon_src_components_personal_TeamMembers_TeamMemberCard_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95664);
/* harmony import */ var _prezzee_ribbon_src_components_personal_TeamMembers_TeamMembersBlock_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47177);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE
















var section = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .section */ .qi,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(1240)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(100)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .belowLargeScreen */ .Qo, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var heading = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Personal.charcoal */ .RL.charcoal),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(36)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .desktop */ .gv, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                                    tl: /* [] */ 0
                                }
                            }
                        }),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tablet */ .Mq, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(36)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(46)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var Styles = {
    section: section,
    heading: heading
};
function MeetTheTeam(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var title = block.title;
    var blockTitle = title === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h2", {
        children: title,
        className: heading
    });
    var perRow;
    switch(block.cards_per_row){
        case "five":
            perRow = /* Five */ 2;
            break;
        case "four":
            perRow = /* Four */ 1;
            break;
        case "three":
            perRow = /* Three */ 0;
            break;
        default:
            perRow = /* Four */ 1;
    }
    var cards = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_13__/* .mapWithIndex */ .Su(block.team_member_cards, function(idx, cardContent) {
        var key = String(idx);
        var smartLink = cardContent.smartLink;
        var link = cardContent.link;
        var name = cardContent.name;
        var photo_front = cardContent.photo_front;
        var photoFront = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
            src: photo_front.url,
            alt: name,
            width: photo_front.width,
            height: photo_front.height,
            sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletSm */ .FV + " 100vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletOrMobile */ .k$ + " 482px, 286px"
        });
        var photoBack = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithDefault */ .k7(cardContent.photo_back, undefined, function(pb) {
            return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_15__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
                src: pb.url,
                alt: name,
                width: pb.width,
                height: pb.height,
                sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletSm */ .FV + " 100vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletOrMobile */ .k$ + " 482px, 286px"
            }));
        });
        var nameEl = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h2", {
            children: name
        });
        var titleEl = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h2", {
            children: cardContent.title
        });
        var descEl = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_7__.make, {
            children: cardContent.description
        });
        var card = link !== undefined ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: link,
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_TeamMembers_TeamMemberCard_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .Sy, {
                    photoFront: photoFront,
                    photoBack: photoBack,
                    name: nameEl,
                    title: titleEl,
                    description: descEl
                })
            })
        }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_TeamMembers_TeamMemberCard_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .Sy, {
            photoFront: photoFront,
            photoBack: photoBack,
            name: nameEl,
            title: titleEl,
            description: descEl
        });
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                    children: card
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        }, key);
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("section", {
                children: [
                    blockTitle,
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_TeamMembers_TeamMembersBlock_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                        children: cards,
                        perRow: perRow
                    })
                ],
                className: section
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var Link$1;
var make = MeetTheTeam;
 /* section Not a pure module */ 


/***/ }),

/***/ 5869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Helpers; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92592);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34442);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25400);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72721);
/* harmony import */ var _index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81343);
// Generated by ReScript, PLEASE EDIT WITH CARE










function cmsImg(w) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(w)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .height */ .Cb8("auto"),
            tl: /* [] */ 0
        }
    });
}
var Styles = {
    cmsImg: cmsImg
};
function getImageOption(opt) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .mapWithDefault */ .k7(opt, undefined, function(img) {
        var width = img.width;
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
            src: img.url,
            alt: img.description,
            width: width,
            height: img.height,
            className: cmsImg(width),
            sizes: "" + String(width) + "px"
        }));
    });
}
function getAssetOption(opt) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .mapWithDefault */ .k7(opt, undefined, function(img) {
        var width = img.width;
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
            src: img.url,
            alt: img.description,
            width: width,
            height: img.height,
            className: cmsImg(width),
            sizes: "" + String(width) + "px"
        }));
    });
}
function getImageOptionWithSizes(opt, sizes) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .mapWithDefault */ .k7(opt, undefined, function(img) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
            src: img.url,
            alt: img.description,
            width: img.width,
            height: img.height,
            sizes: sizes
        }));
    });
}
function getAssetOptionWithSizes(opt, sizes) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .mapWithDefault */ .k7(opt, undefined, function(img) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
            src: img.url,
            alt: img.description,
            width: img.width,
            height: img.height,
            sizes: sizes
        }));
    });
}
function getImages(images) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_9__/* .mapWithIndex */ .Su(images, function(idx, img) {
        var key = String(idx);
        if (img.NAME === "DeviceSizeImage") {
            var _$images = img.VAL;
            var smartLink = _$images.smartLink;
            var imageD = getAssetOption(_$images.desktop_image);
            var imageT = getAssetOption(_$images.tablet_image);
            var imageM = getAssetOption(_$images.mobile_image);
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer.make */ .$.make, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S, {
                            desktop: imageD,
                            smallScreen: imageT,
                            tablet: undefined,
                            mobile: imageM
                        })
                    })
                }),
                itemId: smartLink.itemId,
                elementCodename: smartLink.codename
            }, key);
        }
        var img$1 = img.VAL;
        var smartLink$1 = img$1.smartLink;
        var width = img$1.width;
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
                        src: img$1.url,
                        alt: img$1.description,
                        width: width,
                        height: img$1.height,
                        className: cmsImg(width),
                        sizes: "" + String(width) + "px"
                    })
                })
            }),
            itemId: smartLink$1.itemId,
            elementCodename: smartLink$1.codename
        }, key);
    });
}
var Helpers = {
    KontentContextConsumer: undefined,
    DeviceSizeImage: undefined,
    getImageOption: getImageOption,
    getAssetOption: getAssetOption,
    getImageOptionWithSizes: getImageOptionWithSizes,
    getAssetOptionWithSizes: getAssetOptionWithSizes,
    getImages: getImages
};
 /* BsCss Not a pure module */ 


/***/ }),

/***/ 36631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_ribbon_src_components_common_CategoryTiles_CategoryTiles_gen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85268);
/* harmony import */ var _prezzee_ribbon_src_components_common_CategoryTiles_CategoryTiles_Single_gen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65891);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Button_Button_gen__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2770);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70965);
/* harmony import */ var hooks_useSmartLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12427);
/* harmony import */ var components_CmsImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73450);
/* harmony import */ var css_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55374);
/* harmony import */ var common_utils_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4331);













var classes = {
    section: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("max-width:1300px;margin-right:auto;margin-left:auto;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .desktop */ .gv, "{margin-top:6.5rem;margin-bottom:7.5rem;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .tabletOrDesktop */ .ab, "{padding-left:1.875rem !important;padding-right:1.875rem !important;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .tablet */ .Mq, "{margin-top:4.5rem;margin-bottom:3rem;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .mobile */ .ai, "{margin:3.75rem 1.25rem;}"),
    heading: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("font-weight:600;color:", css_theme__WEBPACK_IMPORTED_MODULE_8__/* .Color.Gray800 */ .Il.Gray800, ";@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .desktop */ .gv, "{font-size:40px;line-height:40px;margin-bottom:2rem;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .tablet */ .Mq, "{font-size:32px;line-height:40px;margin-bottom:1.875rem;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .mobile */ .ai, "{font-size:28px;line-height:38px;margin-bottom:0.5rem;}")
};
var Cta = function(param) {
    var button = param.button;
    var variant = button.variant, fill = button.fill, colour = button.colour, cta_url = button.cta_url, cta_text = button.cta_text, open_in_new_window = button.open_in_new_window, smartLink = button.smartLink;
    var spotlightProps = (0,hooks_useSmartLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(smartLink);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_ribbon_src_components_personal_Button_Button_gen__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
        className: "mt-8",
        variant: variant,
        fill: fill,
        colour: colour,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: cta_url,
            prefetch: false,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                target: open_in_new_window ? "_blank" : "",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, spotlightProps), {
                    children: cta_text
                }))
            })
        })
    });
};
var Tile = function(param) {
    var tile = param.tile;
    var title = tile.title, link = tile.link, image = tile.image, labelBackgroundColor = tile.labelBackgroundColor, smartLink = tile.smartLink;
    var spotlightProps = (0,hooks_useSmartLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(smartLink);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: link,
            prefetch: false,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, spotlightProps), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_ribbon_src_components_common_CategoryTiles_CategoryTiles_Single_gen__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                    text: title,
                    labelBackgroundColor: labelBackgroundColor.length ? labelBackgroundColor : void 0,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_CmsImage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        src: image.url,
                        alt: image.description,
                        width: image.width,
                        height: image.height,
                        sizes: "".concat(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .mobile */ .ai, " 44vw, 290px}")
                    })
                })
            }))
        })
    });
};
var CategoryTilesSection = function(param) {
    var block = param.block;
    var tiles = block.tiles, title = block.title, button = block.button, smartLink = block.smartLink;
    var spotlightProps = (0,hooks_useSmartLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(smartLink);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        className: classes.section
    }, spotlightProps), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h2", {
                className: classes.heading,
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_prezzee_ribbon_src_components_common_CategoryTiles_CategoryTiles_gen__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                children: tiles.map(function(t, idx) {
                    return t.image ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(Tile, {
                        tile: t
                    }, idx) : common_utils_react__WEBPACK_IMPORTED_MODULE_9__/* .EMPTY_ELEMENT */ .O;
                })
            }),
            button ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(Cta, {
                button: button
            }) : common_utils_react__WEBPACK_IMPORTED_MODULE_9__/* .EMPTY_ELEMENT */ .O
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryTilesSection);


/***/ }),

/***/ 45305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports KontentContextConsumer, Styles, Content */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34442);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(72491);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28848);
/* harmony import */ var _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37110);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Text_Text_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25519);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72721);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28522);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_personal_DownloadAppsBanner_DownloadAppsBanner_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88288);
// Generated by ReScript, PLEASE EDIT WITH CARE
















function container(bgColor) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100.0)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .background */ .Oq0({
                NAME: "linearGradient",
                VAL: [
                    {
                        NAME: "deg",
                        VAL: 0
                    },
                    [
                        [
                            _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(55),
                            bgColor
                        ],
                        [
                            _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(45),
                            "transparent"
                        ]
                    ]
                ]
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.375)),
                tl: /* [] */ 0
            }
        }
    });
}
var appBadge = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_12__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(52))),
    tl: /* [] */ 0
});
var Styles = {
    container: container,
    appBadge: appBadge
};
function makeBadge(index, badge) {
    var smartLink = badge.smartLink;
    var elementCodename = smartLink.codename;
    var itemId = smartLink.itemId;
    var app_store_download_link = badge.app_store_download_link;
    var app_store_image = badge.app_store_image;
    var image;
    if (app_store_image !== undefined) {
        var height = app_store_image.height;
        var width = app_store_image.width;
        image = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
            src: app_store_image.url,
            alt: app_store_image.description,
            width: width !== 0 ? width : 156,
            height: height !== 0 ? height : 52,
            className: appBadge
        });
    } else {
        image = null;
    }
    if (app_store_download_link === "") {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("span", {
                        children: image
                    })
                })
            }),
            itemId: itemId,
            elementCodename: elementCodename
        }, String(index));
    } else {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("a", {
                    children: image,
                    title: badge.app_store_name,
                    href: app_store_download_link
                })
            }),
            itemId: itemId,
            elementCodename: elementCodename
        }, String(index));
    }
}
function makeBlock(index, block) {
    var smartLink = block.smartLink;
    var icon = block.icon;
    var icon$1;
    if (icon !== undefined) {
        var height = icon.height;
        var width = icon.width;
        icon$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                    src: icon.url,
                    alt: icon.description,
                    width: width !== 0 ? width : 32,
                    height: height !== 0 ? height : 32,
                    sizes: "32px"
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
    } else {
        icon$1 = null;
    }
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            icon$1,
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_Text_Text_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .S, {
                    children: block.title
                })
            })
        ]
    }, String(index));
}
function getBackgroundImage(image) {
    if (image !== undefined) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
            src: image.url,
            alt: image.description,
            width: image.width,
            height: image.height,
            sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .smallScreenOrMobile */ .HH + " 100vw, 700px"
        });
    } else {
        return null;
    }
}
function getDescription(description) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_8__.make, {
        children: description
    });
}
function getBadges(badges) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(badges, makeBadge);
}
function getBlocks(blocks) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(blocks, makeBlock);
}
var Content = {
    makeBadge: makeBadge,
    makeBlock: makeBlock,
    getBackgroundImage: getBackgroundImage,
    getDescription: getDescription,
    getBadges: getBadges,
    getBlocks: getBlocks
};
function DownloadAppsSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var theme = _prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .useTheme */ .Fg(undefined);
    var state = _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .useContext */ .qp(undefined);
    var footer = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_15__/* .flatMap */ .VS(state, function(s) {
        return s.footer;
    });
    var bgColor = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_15__/* .mapWithDefault */ .k7(footer, theme.components.footer.backgroundColor, function(s) {
        return s.theme.backgroundColor;
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("section", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_DownloadAppsBanner_DownloadAppsBanner_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .Sy, {
                        blocks: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(block.selling_points, makeBlock),
                        background: getBackgroundImage(block.background_image),
                        mobileBackground: getBackgroundImage(block.mobile_background_image),
                        badges: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(block.app_stores, makeBadge),
                        description: getDescription(block.description),
                        heading: block.title
                    }),
                    className: _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .section */ .qi
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        }),
        className: container(bgColor)
    });
}
var KontentContextConsumer;
var make = DownloadAppsSection;
 /* appBadge Not a pure module */ 


/***/ }),

/***/ 89307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports KontentContextConsumer, SectionStyles, AccordionBlock */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(72491);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28848);
/* harmony import */ var _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37110);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72721);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34891);
/* harmony import */ var _prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28522);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_Panel_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23864);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_Heading_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50700);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_Trigger_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75421);
// Generated by ReScript, PLEASE EDIT WITH CARE















function container(bgColor) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .backgroundColor */ .Czw(bgColor),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.25)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .tablet */ .Mq, {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2.8125)),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .tabletSm */ .FV, {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.25)),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("button:focus", {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .outlineWidth */ .bu0("zero"),
                            tl: /* [] */ 0
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    });
}
var panel = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(14)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("p", {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.em(1.2)),
                tl: /* [] */ 0
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("p:last-of-type", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var SectionStyles = {
    container: container,
    panel: panel
};
function FullWidthTextSection$AccordionBlock(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs(_prezzee_ribbon_src_components_personal_Accordion_Accordion_bs_js__WEBPACK_IMPORTED_MODULE_7__.make, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_Accordion_Accordion_Heading_bs_js__WEBPACK_IMPORTED_MODULE_11__.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_Accordion_Accordion_Trigger_bs_js__WEBPACK_IMPORTED_MODULE_12__.make, {
                    children: props.heading
                })
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_Accordion_Accordion_Panel_bs_js__WEBPACK_IMPORTED_MODULE_9__.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_6__.make, {
                        children: props.description
                    }),
                    className: panel
                })
            })
        ],
        colour: /* White */ 2
    });
}
var AccordionBlock = {
    themeColour: /* White */ 2,
    make: FullWidthTextSection$AccordionBlock
};
function FullWidthTextSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var theme = _prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .useTheme */ .Fg(undefined);
    var state = _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .useContext */ .qp(undefined);
    var footer = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_14__/* .flatMap */ .VS(state, function(s) {
        return s.footer;
    });
    var bgColor = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithDefault */ .k7(footer, theme.components.footer.backgroundColor, function(s) {
        return s.theme.backgroundColor;
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("section", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(FullWidthTextSection$AccordionBlock, {
                        heading: block.title,
                        description: block.description
                    }),
                    className: _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .section */ .qi
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        }),
        className: container(bgColor)
    });
}
var KontentContextConsumer;
var make = FullWidthTextSection;
 /* panel Not a pure module */ 


/***/ }),

/***/ 21735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports KontentContextConsumer, getBgImage, LargeTile, VideoModal, SmallTile, TwoTiles, FullWidthTile, Styles */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(20859);
/* harmony import */ var _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91574);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(92592);
/* harmony import */ var _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(7618);
/* harmony import */ var _css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93802);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34442);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(37712);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(72491);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Modal_Modal_bs_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(50952);
/* harmony import */ var _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51741);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10573);
/* harmony import */ var _prezzee_ribbon_src_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17847);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72721);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Modal_Modal_Close_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78804);
/* harmony import */ var _prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28522);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17845);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_bs_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30973);
/* harmony import */ var _prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_bs_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(94269);
/* harmony import */ var _prezzee_ribbon_src_components_personal_TwoOneHeroTiles_TwoOneHeroTiles_bs_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(92061);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67814);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Modal_Modal_Container_bs_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(95157);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(32567);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(99956);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(64797);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22169);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Heading_bs_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(79690);
/* harmony import */ var _prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(18833);
/* harmony import */ var _prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_Heading_bs_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(59007);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(80465);
/* harmony import */ var _prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(81255);
/* harmony import */ var _prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_CardImage_bs_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(8928);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Background_bs_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(49914);
/* harmony import */ var _prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Foreground_bs_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(32569);
/* harmony import */ var _prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_Background_bs_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(11762);
/* harmony import */ var _prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_Foreground_bs_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(20213);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faPlay__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(753);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_MobileAwareVideo_bs_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(84318);
// Generated by ReScript, PLEASE EDIT WITH CARE














































function getBgImage(url) {
    return url + "?fm=png&auto=format";
}
function ctaImageContainer(url, tabletUrl, mobileUrl, bgColor) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .cursor */ .ocY("pointer"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0l(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("inlineBlock"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("relative"),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .margin */ .e6$("auto"),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundColor */ .Czw({
                                    NAME: "hex",
                                    VAL: bgColor
                                }),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundSize */ .G4q("contain"),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundImage */ .NxW({
                                            NAME: "url",
                                            VAL: url
                                        }),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundRepeat */ .FDc("noRepeat"),
                                            tl: {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
                                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundImage */ .NxW({
                                                        NAME: "url",
                                                        VAL: mobileUrl
                                                    })),
                                                    tl: /* [] */ 0
                                                }),
                                                tl: {
                                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.tablet */ .KM.tablet, {
                                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundImage */ .NxW({
                                                            NAME: "url",
                                                            VAL: tabletUrl
                                                        })),
                                                        tl: /* [] */ 0
                                                    }),
                                                    tl: /* [] */ 0
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    });
}
function ctaImageAction(isInfo) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingTop */ .odA(isInfo ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(20) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(80)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingBottom */ .EtG(isInfo ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(30) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingLeft */ .rv2(isInfo ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(67) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingRight */ .WLm(isInfo ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(67) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU(isInfo ? "relative" : "absolute"),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$v(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .IaC(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .margin */ .e6$("auto"),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingLeft */ .rv2(isInfo ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(20) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                                            tl: {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingRight */ .WLm(isInfo ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(20) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                                                tl: /* [] */ 0
                                            }
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    });
}
var ctaVideoContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .cursor */ .ocY("pointer"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .minHeight */ .jw4(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(200)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0l(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("inlineBlock"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("relative"),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundSize */ .G4q("contain"),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .margin */ .e6$("auto"),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var ctaVideoAction = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(80)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("absolute"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$v(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .IaC(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(40)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .margin */ .e6$("auto"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var noImageContentContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("row"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("spaceBetween"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("column"),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.tablet */ .KM.tablet, {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("column"),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
function noImageContentHead(textColor) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("h1, h2, h3, h4, h5, h6, p", {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(textColor ? _css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.white */ .Il.white : "currentColor")),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    });
}
var noImageContentAction = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(35)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
            tl: /* [] */ 0
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.tablet */ .KM.tablet, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(0)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var videoBannerLink = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("absolute"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .wey("zero"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$v("zero"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zIndex */ .W5D(10),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var backgroundImageStyle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var transparentBannerImage = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .visibility */ .WDY("hidden"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
            tl: /* [] */ 0
        }
    }
});
function backgroundStyle(url) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundImage */ .NxW({
            NAME: "url",
            VAL: url
        }),
        tl: /* [] */ 0
    });
}
function mobileBackgroundStyle(url) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundImage */ .NxW({
                NAME: "url",
                VAL: url
            })),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    });
}
function bgColorStyle(bgColor) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafe */ .K47("backgroundColor", bgColor),
        tl: /* [] */ 0
    });
}
var foregroundDark = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y("currentColor"),
    tl: /* [] */ 0
});
var foregroundLight = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("h1, h2, h3, h4, h5, h6, p", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.white */ .Il.white)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
function videoContainer(theme) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("absolute"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2z(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zero */ .bMI),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .wey(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zero */ .bMI),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .overflow */ .txR("hidden"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderTopRightRadius */ .E$t(theme.borderRadius),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .minHeight */ .jw4(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(200)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.tabletOrDesktop */ .KM.tabletOrDesktop, {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderBottomRightRadius */ .rfy(theme.borderRadius),
                                        tl: /* [] */ 0
                                    }
                                }),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderTopLeftRadius */ .orU(theme.borderRadius),
                                            tl: /* [] */ 0
                                        }
                                    }),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }
    });
}
var videoPlayer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var ctaVideoPlayer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0l(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobile */ .KM.mobile, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var ctaBannerImageStyles = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .visibility */ .WDY("hidden"),
    tl: /* [] */ 0
});
var container = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flex3 */ .L9u(0, 0, _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy({
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flex3 */ .L9u(0, 0, _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Styles = {
    ctaImageContainer: ctaImageContainer,
    ctaImageAction: ctaImageAction,
    ctaVideoContainer: ctaVideoContainer,
    ctaVideoAction: ctaVideoAction,
    noImageContentContainer: noImageContentContainer,
    noImageContentHead: noImageContentHead,
    noImageContentAction: noImageContentAction,
    videoBannerLink: videoBannerLink,
    backgroundImageStyle: backgroundImageStyle,
    transparentBannerImage: transparentBannerImage,
    backgroundStyle: backgroundStyle,
    mobileBackgroundStyle: mobileBackgroundStyle,
    bgColorStyle: bgColorStyle,
    foregroundDark: foregroundDark,
    foregroundLight: foregroundLight,
    videoContainer: videoContainer,
    videoPlayer: videoPlayer,
    ctaVideoPlayer: ctaVideoPlayer,
    ctaBannerImageStyles: ctaBannerImageStyles,
    container: container
};
function HeroTileSection$LargeTile(props) {
    var tile = props.tile;
    var backgroundImageUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.background_image, "", function(b) {
        return b.url;
    });
    var backgroundImageUrlMobile = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.mobile_background_image, "", function(b) {
        return b.url;
    });
    var backgroundImageUrlTablet = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.tablet_background_image, "", function(b) {
        return b.url;
    });
    var videoUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.background_video, "", function(v) {
        return v;
    });
    var mobileVideoUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.mobile_background_video, "", function(v) {
        return v;
    });
    var tabletVideoUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.tablet_background_video, "", function(v) {
        return v;
    });
    var findBackgroundImage = function findBackgroundImage(width) {
        if (width < _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .largeScreenBreakpoint */ .Rf && width > _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobileBreakpoint */ .KM.mobileBreakpoint) {
            return tile.tablet_background_image;
        } else if (width <= _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobileBreakpoint */ .KM.mobileBreakpoint) {
            return tile.mobile_background_image;
        } else {
            return tile.background_image;
        }
    };
    var findVideoUrl = function findVideoUrl(width) {
        if (width < _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .largeScreenBreakpoint */ .Rf && width > _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobileBreakpoint */ .KM.mobileBreakpoint) {
            return tabletVideoUrl;
        } else if (width <= _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobileBreakpoint */ .KM.mobileBreakpoint) {
            return mobileVideoUrl;
        } else {
            return videoUrl;
        }
    };
    var match = react__WEBPACK_IMPORTED_MODULE_3__.useState(function() {
        return setTimeout(function(param) {}, 0);
    });
    var setIframeTimeout = match[1];
    var iframeTimeout = match[0];
    var initVimeo = function initVimeo(param) {
        clearTimeout(iframeTimeout);
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(setIframeTimeout, function(param) {
            return setTimeout(function(param) {
                var playerDiv = document.getElementById("hero-tile-player");
                if (playerDiv == null) {
                    return;
                }
                var iframe = playerDiv.querySelector("iframe");
                if (!(iframe == null)) {
                    iframe.setAttribute("style", _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_39__/* .concat */ .zo(";border-radius: 10px;", iframe.getAttribute("style")));
                    return;
                }
            }, 1000);
        });
    };
    var match$1 = react__WEBPACK_IMPORTED_MODULE_3__.useState(function() {});
    var setTileImage = match$1[1];
    var tileImage = match$1[0];
    var match$2 = react__WEBPACK_IMPORTED_MODULE_3__.useState(function() {
        return "";
    });
    var setTileVideoUrl = match$2[1];
    var tileVideoUrl = match$2[0];
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
        var width = window.innerWidth;
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(setTileImage, function(param) {
            return findBackgroundImage(width);
        });
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(setTileVideoUrl, function(param) {
            return findVideoUrl(width);
        });
        window.addEventListener("resize", function(param) {
            var width = window.innerWidth;
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(setTileImage, function(param) {
                return findBackgroundImage(width);
            });
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(setTileVideoUrl, function(param) {
                return findVideoUrl(width);
            });
            initVimeo(undefined);
        });
    }, []);
    var validBackgroundImageUrl = backgroundImageUrl !== "";
    var match$3 = react__WEBPACK_IMPORTED_MODULE_3__.useReducer(function(x, param) {
        return x + 1 | 0;
    }, 0);
    var forceUpdate = match$3[1];
    var _$backgroundStyle$1 = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.background_image, "", function(b) {
        return backgroundStyle(b.url + "?fm=png&auto=format");
    });
    var mobileBackgroundStyle$1 = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.mobile_background_image, "", function(b) {
        return mobileBackgroundStyle(b.url + "?fm=png&auto=format");
    });
    var backgroundImageClassName = rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_40__/* .make */ .S([
        _$backgroundStyle$1,
        mobileBackgroundStyle$1
    ]);
    var buttons = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_41__/* .mapWithIndex */ .Su(tile.buttons, function(i, b) {
        var target = b.open_in_new_window ? "_blank" : "";
        var match = b.smartLink;
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_9__.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                href: b.cta_url,
                prefetch: false,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("a", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .Consumer.make */ .$.make, {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("button", {
                                children: b.cta_text
                            })
                        }),
                        itemId: match.itemId,
                        elementCodename: match.codename
                    }),
                    target: target
                })
            }),
            fill: b.fill,
            colour: b.colour,
            variant: b.variant
        }, String(i));
    });
    var match$4 = tile.text_colour;
    var foregroundStyle = match$4 ? foregroundLight : foregroundDark;
    var color = tile.background_colour;
    var backgroundColorStyle = color !== undefined ? bgColorStyle(color) : "";
    var validDesktopUrl = _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_42__/* .vimeoRegex.test */ .pE.test(videoUrl);
    var validMobileUrl = _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_42__/* .vimeoRegex.test */ .pE.test(mobileVideoUrl);
    var invalidMsg = "is not a valid vimeo url.";
    if (!validDesktopUrl && _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .isSome */ .pC(tile.background_video)) {
        _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info({
            type: "Hero Tile Section Desktop Video Url"
        }, 'info: "' + videoUrl + '" ' + invalidMsg + "");
    }
    if (!validMobileUrl && _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .isSome */ .pC(tile.mobile_background_video)) {
        _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info({
            type: "Hero Tile Section Mobile Video Url"
        }, 'info: "' + mobileVideoUrl + '" ' + invalidMsg + "");
    }
    var playerOptions = _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Player.options */ .J.options(undefined, true, undefined, undefined, undefined, false, undefined, tile.loop_background_video, true, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined);
    var match$5 = tile.content_vertical_alignment;
    var contentVerticalAlignment = match$5 === "bottom" ? /* Bottom */ 1 : /* Default */ 0;
    var match$6 = tile.background_horizontal_alignment;
    var backgroundHorizontalAlignment = match$6 === "left" ? /* Left */ 0 : /* Right */ 1;
    var content = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Foreground_bs_js__WEBPACK_IMPORTED_MODULE_33__/* .make */ .S, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Heading_bs_js__WEBPACK_IMPORTED_MODULE_26__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_13__.make, {
                    children: tile.title
                })
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_29__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_13__.make, {
                    children: tile.description
                })
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_25__/* .make */ .S, {
                children: buttons
            })
        ],
        className: foregroundStyle,
        vAlign: contentVerticalAlignment
    });
    var ctaContent = null;
    var noImageContent = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("div", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Heading_bs_js__WEBPACK_IMPORTED_MODULE_26__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_13__.make, {
                            children: tile.title
                        })
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_29__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_13__.make, {
                            children: tile.description
                        })
                    })
                ],
                className: noImageContentHead(tile.text_colour)
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_25__/* .make */ .S, {
                    children: buttons
                }),
                className: noImageContentAction
            })
        ],
        className: noImageContentContainer
    });
    var player = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_24__/* .make */ .Sy, {
        className: videoPlayer,
        id: "hero-tile-player",
        playerOptions: playerOptions,
        maintainAspectByHeight: true
    });
    var ctaPlayer = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_24__/* .make */ .Sy, {
        className: ctaVideoPlayer,
        id: "hero-tile-player",
        playerOptions: playerOptions,
        maintainAspectByHeight: true
    });
    var theme = _prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg(undefined);
    var video = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_23__/* .make */ .S, {
            videoUrl: videoUrl,
            children: player
        }),
        className: videoContainer(theme)
    });
    var mobileVideo = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_MobileAwareVideo_bs_js__WEBPACK_IMPORTED_MODULE_36__/* .make */ .S, {
            videoUrl: videoUrl,
            mobileUrl: mobileVideoUrl,
            children: player,
            mobileBreakpoint: _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobileBreakpoint */ .KM.mobileBreakpoint
        }),
        className: videoContainer(theme)
    });
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(forceUpdate, undefined);
        initVimeo(undefined);
    }, []);
    var match$7 = tile.smartLink;
    var ctaLink = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_41__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_41__/* .map */ .UI(tile.buttons, function(b) {
        return b.cta_url;
    }), 0);
    var ctaBannerImage = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: String(ctaLink),
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Background_bs_js__WEBPACK_IMPORTED_MODULE_32__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("div", {
                    children: [
                        validBackgroundImageUrl && tileImage !== undefined ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                            src: tileImage.url,
                            alt: tileImage.description,
                            width: tileImage.width,
                            height: tileImage.height,
                            className: transparentBannerImage,
                            sizes: "(min-width: 1440px) 1380px, 100vw",
                            priority: true
                        }) : null,
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                            children: validBackgroundImageUrl ? ctaContent : noImageContent,
                            className: ctaImageAction(tile.infoCta)
                        })
                    ],
                    className: ctaImageContainer(backgroundImageUrl + "?fm=png&auto=format", backgroundImageUrlTablet + "?fm=png&auto=format", backgroundImageUrlMobile + "?fm=png&auto=format", String(tile.background_colour))
                }),
                backgroundImageClassName: backgroundImageStyle,
                backgroundColorClassName: backgroundColorStyle,
                alignBackground: backgroundHorizontalAlignment
            })
        })
    });
    var ctaBannerVideo = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                href: String(ctaLink),
                prefetch: false,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                    className: videoBannerLink
                })
            }),
            validDesktopUrl && validMobileUrl ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_MobileAwareVideo_bs_js__WEBPACK_IMPORTED_MODULE_36__/* .make */ .S, {
                videoUrl: tileVideoUrl,
                mobileUrl: mobileVideoUrl,
                children: ctaPlayer,
                mobileBreakpoint: _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .CategoryTiles.mobileBreakpoint */ .KM.mobileBreakpoint
            }) : validDesktopUrl ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_23__/* .make */ .S, {
                videoUrl: tileVideoUrl,
                children: ctaPlayer
            }) : null,
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                children: ctaContent,
                className: ctaVideoAction
            })
        ],
        className: ctaVideoContainer
    });
    var banner = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_Background_bs_js__WEBPACK_IMPORTED_MODULE_32__/* .make */ .S, {
        children: [
            validDesktopUrl && validMobileUrl ? mobileVideo : validDesktopUrl ? video : null,
            content
        ],
        backgroundImageClassName: backgroundImageClassName,
        backgroundColorClassName: backgroundColorStyle,
        alignBackground: backgroundHorizontalAlignment
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_LargeHeroTile_LargeHeroTile_bs_js__WEBPACK_IMPORTED_MODULE_17__/* .make */ .Sy, {
                    children: tile.cta ? validDesktopUrl && validMobileUrl ? ctaBannerVideo : ctaBannerImage : banner
                }, match$3[0].toString()),
                className: container
            })
        }),
        itemId: match$7.itemId,
        elementCodename: match$7.codename
    });
}
var LargeTile = {
    Styles: Styles,
    make: HeroTileSection$LargeTile
};
var videoContainer$1 = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zero */ .bMI),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(56.25)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy({
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("absolute"),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .wey(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(50)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$v(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zero */ .bMI),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transform */ .vs({
                                NAME: "translateY",
                                VAL: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(-50)
                            }),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxHeight */ .kCL(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.vh(90)),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }),
            tl: /* [] */ 0
        }
    }
});
function playButtonContainer(foregroundColor) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(foregroundColor ? _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_16__/* .white */ .ix : _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_16__/* .gray600 */ .RA),
                tl: /* [] */ 0
            }
        }
    });
}
var playButton = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginRight */ .wzR(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("button", {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderWidth */ .J4J(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(1))),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(14))),
                tl: /* [] */ 0
            }
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy({
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .nthChild */ .vvq({
                    NAME: "add",
                    VAL: [
                        1,
                        2
                    ]
                }, {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginLeft */ .oIA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10))),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var Styles$1 = {
    videoContainer: videoContainer$1,
    playButtonContainer: playButtonContainer,
    playButton: playButton
};
function HeroTileSection$VideoModal(props) {
    var foregroundColor = props.foregroundColor;
    var match = react__WEBPACK_IMPORTED_MODULE_3__.useState(function() {
        return false;
    });
    var setModalOpen = match[1];
    var onRequestClose = function onRequestClose(param) {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(setModalOpen, function(param) {
            return false;
        });
    };
    var openFunc = function openFunc(param) {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(setModalOpen, function(param) {
            return true;
        });
    };
    var playerOptions = _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Player.options */ .J.options(undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined);
    var content = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_23__/* .make */ .S, {
            videoUrl: props.videoUrl,
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_24__/* .make */ .Sy, {
                id: "video-modal-story",
                playerOptions: playerOptions
            })
        }),
        className: videoContainer$1
    });
    var btnColor = foregroundColor ? /* White */ 2 : /* Tertiary */ 7;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_Modal_Modal_bs_js__WEBPACK_IMPORTED_MODULE_43__.make, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("div", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_9__.make, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("button", {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_19__.FontAwesomeIcon, {
                                icon: _fortawesome_free_solid_svg_icons_faPlay__WEBPACK_IMPORTED_MODULE_44__/* .faPlay */ .zc
                            }),
                            onClick: openFunc
                        }),
                        fill: /* Outlined */ 1,
                        colour: btnColor,
                        variant: /* Icon */ 2,
                        className: playButton
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .Media.make */ .pU.make, {
                        greaterThan: "rbMobile",
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("span", {
                            children: props.ctaText,
                            className: _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_22__/* .Styles.style6 */ .z.style6
                        })
                    })
                ],
                className: playButtonContainer(foregroundColor)
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_Modal_Modal_Container_bs_js__WEBPACK_IMPORTED_MODULE_20__.make, {
                id: "small-hero-modal-container",
                isOpen: match[0],
                onRequestClose: onRequestClose,
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Modal_Modal_Close_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .S, {
                        closeFunc: onRequestClose
                    }),
                    content
                ],
                borderless: true
            })
        ]
    });
}
var VideoModal = {
    Styles: Styles$1,
    make: HeroTileSection$VideoModal
};
function backgroundStyle$1(url) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundImage */ .NxW({
            NAME: "url",
            VAL: url
        }),
        tl: /* [] */ 0
    });
}
var foregroundDark$1 = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y("currentColor"),
    tl: /* [] */ 0
});
var foregroundLight$1 = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("h1, h2, h3, h4, h5, h6, p", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.white */ .Il.white)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
function foregroundImage(w, h) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(w)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(h)),
            tl: /* [] */ 0
        }
    });
}
var container$1 = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flex3 */ .L9u(0, 0, _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy({
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flex3 */ .L9u(0, 0, _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Styles$2 = {
    backgroundStyle: backgroundStyle$1,
    foregroundDark: foregroundDark$1,
    foregroundLight: foregroundLight$1,
    foregroundImage: foregroundImage,
    container: container$1
};
function HeroTileSection$SmallTile(props) {
    var tile = props.tile;
    var match = react__WEBPACK_IMPORTED_MODULE_3__.useReducer(function(x, param) {
        return x + 1 | 0;
    }, 0);
    var smartLink = tile.smartLink;
    var foreground_image = tile.foreground_image;
    var text_colour = tile.text_colour;
    var forceUpdate = match[1];
    var backgroundImageClassName = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.background_image, "", function(b) {
        return backgroundStyle$1(b.url + "?fm=png&auto=format");
    });
    var foregroundStyle = text_colour ? foregroundLight$1 : foregroundDark$1;
    var image;
    if (foreground_image !== undefined) {
        var height = foreground_image.height;
        var width = foreground_image.width;
        image = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_CardImage_bs_js__WEBPACK_IMPORTED_MODULE_31__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                src: foreground_image.url,
                alt: foreground_image.description,
                width: width,
                height: height,
                className: foregroundImage(width, height),
                sizes: "285px",
                priority: true
            })
        });
    } else {
        image = null;
    }
    var videoUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .mapWithDefault */ .k7(tile.background_video, "", function(v) {
        return v;
    });
    var validVideoUrl = _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_42__/* .vimeoRegex.test */ .pE.test(videoUrl);
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(forceUpdate, undefined);
    }, []);
    var btns = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_41__/* .mapWithIndex */ .Su(tile.buttons, function(i, b) {
        var target = b.open_in_new_window ? "_blank" : "";
        var match = b.smartLink;
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_9__.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                href: b.cta_url,
                prefetch: false,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("a", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .Consumer.make */ .$.make, {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("button", {
                                children: b.cta_text
                            })
                        }),
                        itemId: match.itemId,
                        elementCodename: match.codename
                    }),
                    target: target
                })
            }),
            fill: b.fill,
            colour: b.colour,
            variant: b.variant
        }, String(i));
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_bs_js__WEBPACK_IMPORTED_MODULE_45__/* .make */ .Sy, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_Background_bs_js__WEBPACK_IMPORTED_MODULE_34__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_Foreground_bs_js__WEBPACK_IMPORTED_MODULE_35__/* .make */ .S, {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_Heading_bs_js__WEBPACK_IMPORTED_MODULE_28__/* .make */ .S, {
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_13__.make, {
                                        children: tile.title
                                    })
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_30__/* .make */ .S, {
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_13__.make, {
                                        children: tile.description
                                    })
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(_prezzee_ribbon_src_components_personal_SmallHeroTile_SmallHeroTile_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_27__/* .make */ .S, {
                                    children: [
                                        btns,
                                        validVideoUrl ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(HeroTileSection$VideoModal, {
                                            videoUrl: videoUrl,
                                            ctaText: tile.video_cta_text,
                                            foregroundColor: text_colour
                                        }) : null
                                    ]
                                })
                            ],
                            image: image,
                            className: foregroundStyle
                        }),
                        backgroundImageClassName: backgroundImageClassName
                    })
                }, match[0].toString()),
                className: container$1
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var SmallTile = {
    Styles: Styles$2,
    make: HeroTileSection$SmallTile
};
function HeroTileSection$TwoTiles(props) {
    var leftTile = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(HeroTileSection$LargeTile, {
        tile: props.tile1
    });
    var rightTile = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(HeroTileSection$SmallTile, {
        tile: props.tile2
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_TwoOneHeroTiles_TwoOneHeroTiles_bs_js__WEBPACK_IMPORTED_MODULE_18__/* .make */ .S, {
        leftTile: leftTile,
        rightTile: rightTile
    });
}
var TwoTiles = {
    make: HeroTileSection$TwoTiles
};
function HeroTileSection$FullWidthTile(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(HeroTileSection$LargeTile, {
        tile: props.tile
    });
}
var FullWidthTile = {
    make: HeroTileSection$FullWidthTile
};
function section(top_distance, bottom_distance) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_37__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .isNone */ .Wi(top_distance) ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(0.75) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .getWithDefault */ .tj(top_distance, 0))),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .isNone */ .Wi(bottom_distance) ? _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2.5) : _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_38__/* .getWithDefault */ .tj(bottom_distance, 0))),
            tl: /* [] */ 0
        }
    });
}
var Styles$3 = {
    section: section
};
function HeroTileSection(props) {
    var block = props.block;
    var match = block.smartLink;
    var match$1 = block.block_style;
    var tiles;
    switch(match$1){
        case /* TwoOneStack */ 0:
            var match$2 = block.hero_tiles;
            if (match$2.length !== 2) {
                tiles = null;
            } else {
                var tile1 = match$2[0];
                var tile2 = match$2[1];
                tiles = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(HeroTileSection$TwoTiles, {
                    tile1: tile1,
                    tile2: tile2
                });
            }
            break;
        case /* TiledOffset */ 1:
            tiles = null;
            break;
        case /* FullWidth */ 2:
            var match$3 = block.hero_tiles;
            if (match$3.length !== 1) {
                tiles = null;
            } else {
                var tile = match$3[0];
                tiles = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(HeroTileSection$FullWidthTile, {
                    tile: tile
                });
            }
            break;
    }
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("section", {
                children: tiles,
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_40__/* .make */ .S([
                    _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .fullWidthSection */ .wt,
                    section(block.top_distance, block.bottom_distance)
                ])
            })
        }),
        itemId: match.itemId,
        elementCodename: match.codename
    });
}
var KontentContextConsumer;
var make = HeroTileSection;
 /* ctaVideoContainer Not a pure module */ 


/***/ }),

/***/ 86072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make$1; }
/* harmony export */ });
/* unused harmony exports KontentContextConsumer, NewsletterForm, $$Image, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25400);
/* harmony import */ var _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43243);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28848);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10573);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72721);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26396);
/* harmony import */ var _library_NewsletterSubscription_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20025);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_components_personal_TextField_TextField_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98923);
/* harmony import */ var _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62323);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55303);
/* harmony import */ var _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_Heading_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90168);
/* harmony import */ var _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_Success_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41988);
/* harmony import */ var _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(66350);
// Generated by ReScript, PLEASE EDIT WITH CARE




















var input = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_17__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .tabletSmUp */ .Uv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(415)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var Styles = {
    input: input
};
function make(param) {
    var block = param.block;
    var button = block.button;
    var smartLink = button.smartLink;
    var form = param.form;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("form", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(_prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_CtaLine_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .S, {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_TextField_TextField_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .Sy, {
                    className: input,
                    label: block.input_box_placeholder_text,
                    name: "email_address",
                    type_: "email",
                    error: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_18__/* .isSome */ .pC(_utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .getFieldError */ .zQ(form.errors, "email_address")),
                    helperText: _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .getFieldError */ .zQ(form.errors, "email_address"),
                    inputRef: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_19__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_17__._1(form.register, _library_NewsletterSubscription_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .newsletterInput */ .T))
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Consumer.make */ .$.make, {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("button", {
                                children: button.cta_text,
                                disabled: form.formState.isSubmitted,
                                type: "submit"
                            })
                        }),
                        itemId: smartLink.itemId,
                        elementCodename: smartLink.codename
                    }),
                    fill: button.fill,
                    colour: button.colour,
                    variant: button.variant,
                    shadow: /* Normal */ 1
                })
            ]
        }),
        onSubmit: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_17__._2(form.handleSubmit, param.onSubmit, _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .onError */ .qQ)
    });
}
var NewsletterSection$NewsletterForm = make;
var NewsletterForm = {
    Styles: Styles,
    make: NewsletterSection$NewsletterForm
};
var successImg = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_17__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(38))),
    tl: /* [] */ 0
});
function getBackgroundStyle(desktop, tablet, mobile) {
    var fallbackBg = desktop !== undefined ? desktop.url : tablet !== undefined ? tablet.url : mobile !== undefined ? mobile.url : "/images/ribbon.png";
    var bgDesktop = desktop !== undefined ? desktop.url : fallbackBg;
    var bgTablet = tablet !== undefined ? tablet.url : fallbackBg;
    var bgMobile = mobile !== undefined ? mobile.url : tablet !== undefined ? tablet.url : fallbackBg;
    return _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .Styles.backgroundImages */ .z0.backgroundImages(bgDesktop, bgTablet, bgMobile);
}
var Styles$1 = {
    successImg: successImg,
    getBackgroundStyle: getBackgroundStyle
};
function NewsletterSection(props) {
    var store = props.store;
    var block = props.block;
    var store$1 = store !== undefined ? store : "consumer";
    var smartLink = block.smartLink;
    var backgroundStyle = getBackgroundStyle(block.background_image, block.background_image_tablet, block.background_image_mobile);
    var successElement = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(_prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_Success_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .make */ .S, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/confetti.png",
                alt: "Confetti",
                width: 38,
                height: 37,
                className: successImg
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("p", {
                children: block.success_message
            })
        ]
    });
    var newsletterFormBuilder = function newsletterFormBuilder(input) {
        return make({
            block: block,
            form: input.form,
            onSubmit: input.onSubmit
        });
    };
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("section", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(_prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .Sy, {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_Heading_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .S, {
                            children: block.title
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_BodyText_bs_js__WEBPACK_IMPORTED_MODULE_16__/* .make */ .S, {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_9__.make, {
                                children: block.description
                            })
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_library_NewsletterSubscription_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
                            formComponent: newsletterFormBuilder,
                            successElement: successElement,
                            store: store$1
                        })
                    ],
                    className: backgroundStyle
                }),
                className: _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .section */ .qi
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var KontentContextConsumer;
var $$Image;
var make$1 = NewsletterSection;
 /* input Not a pure module */ 


/***/ }),

/***/ 92330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports PromoTiles, PromoTile, $$Image, Content, DeviceSizeImage, ImageCollectionHelpers, Styles, Builder */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20859);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92592);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34442);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96533);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var _business_ImageCollectionUtil_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5869);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_common_PromoTiles_PromoTile_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61008);
/* harmony import */ var _prezzee_ribbon_src_components_common_PromoTiles_PromoTiles_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22157);
/* harmony import */ var _prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81343);
/* harmony import */ var _prezzee_ribbon_src_components_common_PromoTiles_PromoTile_Image_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1322);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_common_PromoTiles_PromoTile_Content_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30357);
// Generated by ReScript, PLEASE EDIT WITH CARE
















var section = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .desktop */ .gv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(8.4375)),
            tl: /* [] */ 0
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tablet */ .Mq, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(6.25)),
                tl: /* [] */ 0
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .mobile */ .ai, {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(5)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var link = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("block"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
        tl: /* [] */ 0
    }
});
var title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2({
                NAME: "num",
                VAL: 600
            }),
            tl: /* [] */ 0
        }
    }
});
var bg = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("img", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .mobileUp */ .Qm, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$("auto"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr("none"),
                tl: /* [] */ 0
            }
        }),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var Styles = {
    section: section,
    link: link,
    title: title,
    bg: bg
};
function getTileStyle(bgColour) {
    if (bgColour === "") {
        return "";
    } else {
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafe */ .K47("backgroundColor", bgColour)),
            tl: /* [] */ 0
        });
    }
}
function getTextStyle(textColour, desktopTextWidth) {
    var colour = textColour === "" ? "" : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafe */ .K47("color", textColour)),
        tl: /* [] */ 0
    });
    var width = desktopTextWidth === "" ? "" : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .desktop */ .gv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafe */ .K47("maxWidth", desktopTextWidth)),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    });
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
        hd: colour,
        tl: {
            hd: width,
            tl: /* [] */ 0
        }
    });
}
function getIconStyle(iconColour) {
    if (iconColour === "") {
        return "";
    } else {
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafe */ .K47("color", iconColour)),
            tl: /* [] */ 0
        });
    }
}
var Builder = {
    getTileStyle: getTileStyle,
    getTextStyle: getTextStyle,
    getIconStyle: getIconStyle
};
function PromoSection(props) {
    var tileComponents = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(props.block, function(idx, t) {
        var key = String(idx);
        var smartLink = t.smartLink;
        var image = t.image;
        var tileStyle = getTileStyle(t.background_colour);
        var textStyle = getTextStyle(t.text_colour, t.desktop_text_width);
        var iconStyle = getIconStyle(t.icon_colour);
        var match = t.graphic;
        var tmp;
        if (match !== undefined) {
            var src = match.url;
            if (src !== "") {
                var width = match.width;
                tmp = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
                    src: src,
                    alt: match.description,
                    width: width,
                    height: match.height,
                    sizes: "" + String(width) + "px"
                });
            } else {
                tmp = null;
            }
        } else {
            tmp = null;
        }
        var content = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
            children: [
                tmp,
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h3", {
                    children: t.title,
                    className: title
                })
            ]
        });
        var displayImage;
        if (image !== undefined) {
            if (image.NAME === "DeviceSizeImage") {
                var images = image.VAL;
                var imageD = _business_ImageCollectionUtil_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Helpers.getAssetOptionWithSizes */ .Z.getAssetOptionWithSizes(images.desktop_image, "300px");
                var imageT = _business_ImageCollectionUtil_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Helpers.getAssetOptionWithSizes */ .Z.getAssetOptionWithSizes(images.tablet_image, "300px");
                var imageM = _business_ImageCollectionUtil_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Helpers.getAssetOptionWithSizes */ .Z.getAssetOptionWithSizes(images.mobile_image, "300px");
                displayImage = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_PromoTiles_PromoTile_Image_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
                        desktop: imageD,
                        smallScreen: undefined,
                        tablet: imageT,
                        mobile: imageM
                    }),
                    className: bg
                });
            } else {
                var img = image.VAL;
                displayImage = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_PromoTiles_PromoTile_Image_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
                        src: img.url,
                        alt: img.description,
                        width: img.width,
                        height: img.height,
                        sizes: "300px"
                    }),
                    className: bg
                });
            }
        } else {
            displayImage = null;
        }
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: t.link,
            prefetch: false,
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(_prezzee_ribbon_src_components_common_PromoTiles_PromoTile_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .Sy, {
                        children: [
                            displayImage,
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_PromoTiles_PromoTile_Content_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
                                children: content,
                                className: textStyle
                            })
                        ],
                        className: tileStyle,
                        iconStyle: iconStyle
                    }),
                    itemId: smartLink.itemId,
                    elementCodename: smartLink.codename
                }),
                className: link
            })
        }, key);
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("section", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_common_PromoTiles_PromoTiles_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
            children: tileComponents
        }),
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .make */ .S([
            _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .section */ .qi,
            section
        ])
    });
}
var PromoTiles;
var PromoTile;
var $$Image;
var Content;
var DeviceSizeImage;
var ImageCollectionHelpers;
var make = PromoSection;
 /* section Not a pure module */ 


/***/ }),

/***/ 66860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Styles, Content */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96533);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72721);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_components_personal_StatsTile_StatsTile_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17399);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17845);
/* harmony import */ var _prezzee_ribbon_src_components_personal_StatsTile_StatsTileBlock_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77860);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE












var section = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .section */ .qi,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(930)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(5)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(5)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(8.4375)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(8.4375)),
                                tl: /* [] */ 0
                            }
                        }),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(6.25)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(6.25)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var contentContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("flex"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .flexDirection */ .Me8("column"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .justifyContent */ .KlP("center"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .alignItems */ .cq$("center"),
                tl: /* [] */ 0
            }
        }
    }
});
var heading = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("center"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Personal.charcoal */ .RL.charcoal),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(36)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(10)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(12)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(36)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(46)),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(15)),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var description = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("center"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(29)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Personal.midGrey */ .RL.midGrey),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(16)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(18)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(26)),
                                tl: /* [] */ 0
                            }
                        }),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("&:last-child", {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7("zero"),
                                tl: /* [] */ 0
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }
});
var iconImage = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$("auto"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(33)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR("auto"),
                tl: /* [] */ 0
            }
        }
    }
});
function createFluidTypography(minSize, maxSize) {
    var min = String(minSize);
    var max = String(maxSize);
    var calc = "calc(" + min + "px + (" + max + " - " + min + ") * ((100vw - 300px) / (1600 - 300)))";
    var clamp = "clamp(" + min + "px, " + calc + ", " + max + "px)";
    return _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafe */ .K47("fontSize", clamp);
}
var titleBase = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$("zero"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold"),
        tl: /* [] */ 0
    }
});
var subtitleBase = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .opacity */ .Ohi(0.7),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("medium"),
        tl: /* [] */ 0
    }
});
var firstTile_title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: titleBase,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: createFluidTypography(32, 38),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(37)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(10)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .pink300 */ .ME),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(38)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(41)),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(12)),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(34)),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(41)),
                                            tl: {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(11)),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var firstTile_subtitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: titleBase,
    tl: {
        hd: subtitleBase,
        tl: {
            hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
                hd: createFluidTypography(26, 32),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(26)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(31)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .accentBlue */ .H5),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontFamily */ .I85({
                                    NAME: "custom",
                                    VAL: "DM Serif Display"
                                }),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontStyle */ .p_N("italic"),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
                                            tl: {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(41)),
                                                tl: /* [] */ 0
                                            }
                                        }),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(29)),
                                                tl: {
                                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(36)),
                                                    tl: /* [] */ 0
                                                }
                                            }),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var firstTile_background = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .backgroundColor */ .Czw(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .purple400 */ .F0),
    tl: /* [] */ 0
});
var firstTile = {
    title: firstTile_title,
    subtitle: firstTile_subtitle,
    background: firstTile_background
};
var secondTile_title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: titleBase,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: createFluidTypography(52, 70),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(13)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .pink300 */ .ME),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(52)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(41)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(17)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(46)),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(37)),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(15)),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var secondTile_subtitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: titleBase,
    tl: {
        hd: subtitleBase,
        tl: {
            hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
                hd: createFluidTypography(26, 28),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(30)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .white */ .ix),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontFamily */ .I85({
                                NAME: "custom",
                                VAL: "DM Serif Display"
                            }),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontStyle */ .p_N("italic"),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(30)),
                                            tl: /* [] */ 0
                                        }
                                    }),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(25)),
                                            tl: {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(27)),
                                                tl: /* [] */ 0
                                            }
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var secondTile_background = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .backgroundColor */ .Czw(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .red400 */ .kl),
    tl: /* [] */ 0
});
var secondTile = {
    title: secondTile_title,
    subtitle: secondTile_subtitle,
    background: secondTile_background
};
var thirdTile = {
    title: "",
    subtitle: "",
    background: ""
};
var fourthTile_title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: titleBase,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: createFluidTypography(28, 40),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(30)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(33)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(11)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .red400 */ .kl),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(17)),
                                    tl: /* [] */ 0
                                }),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(27)),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(29)),
                                            tl: {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(14)),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var fourthTile_subtitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: titleBase,
    tl: {
        hd: subtitleBase,
        tl: {
            hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
                hd: createFluidTypography(16, 20),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(16)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(22)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .purple400 */ .F0),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontFamily */ .I85({
                                    NAME: "custom",
                                    VAL: "DM Serif Display"
                                }),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontStyle */ .p_N("italic"),
                                    tl: {
                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("center"),
                                        tl: {
                                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .desktop */ .gv, {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                                tl: {
                                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(26)),
                                                    tl: /* [] */ 0
                                                }
                                            }),
                                            tl: {
                                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tablet */ .Mq, {
                                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(17)),
                                                    tl: {
                                                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(23)),
                                                        tl: /* [] */ 0
                                                    }
                                                }),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var fourthTile_background = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_10__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .backgroundColor */ .Czw(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .lilac400 */ ._b),
    tl: /* [] */ 0
});
var fourthTile = {
    title: fourthTile_title,
    subtitle: fourthTile_subtitle,
    background: fourthTile_background
};
var Styles = {
    section: section,
    contentContainer: contentContainer,
    heading: heading,
    description: description,
    iconImage: iconImage,
    createFluidTypography: createFluidTypography,
    titleBase: titleBase,
    subtitleBase: subtitleBase,
    firstTile: firstTile,
    secondTile: secondTile,
    thirdTile: thirdTile,
    fourthTile: fourthTile
};
function StatsTilesSection$Content(props) {
    var style = props.style;
    var subtitle = props.subtitle;
    var title = props.title;
    var tmp = title === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("h4", {
        children: title,
        className: style.title
    });
    var tmp$1 = subtitle === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
            children: subtitle
        }),
        className: style.subtitle
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs("div", {
                children: [
                    tmp,
                    tmp$1
                ],
                className: contentContainer
            })
        }),
        itemId: props.itemId,
        elementCodename: props.elementCodename
    });
}
var Content = {
    KontentContextConsumer: undefined,
    make: StatsTilesSection$Content
};
function StatsTilesSection(props) {
    var block = props.block;
    var description$1 = block.description;
    var title = block.title;
    var blockTitle = title === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("h2", {
        children: title,
        className: heading
    });
    var blockDescription = description$1 === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
            children: description$1
        }),
        className: description
    });
    var tiles = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_11__/* .mapWithIndex */ .Su(block.stats_tiles, function(idx, tile) {
        var smartLink = tile.smartLink;
        var background_image_mobile = tile.background_image_mobile;
        var background_image = tile.background_image;
        var style;
        switch(idx){
            case 0:
                style = firstTile;
                break;
            case 1:
                style = secondTile;
                break;
            case 2:
                style = thirdTile;
                break;
            case 3:
                style = fourthTile;
                break;
            default:
                style = fourthTile;
        }
        var content = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(StatsTilesSection$Content, {
            title: tile.title,
            subtitle: tile.subtitle,
            style: style,
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
        var backgroundImage = background_image !== undefined ? background_image.url : undefined;
        var backgroundImageMobile = background_image_mobile !== undefined ? background_image_mobile.url : undefined;
        var className;
        switch(idx){
            case 0:
                className = firstTile_background;
                break;
            case 1:
                className = secondTile_background;
                break;
            case 2:
                className = "";
                break;
            case 3:
                className = fourthTile_background;
                break;
            default:
                className = fourthTile_background;
        }
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_personal_StatsTile_StatsTile_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .Sy, {
            content: content,
            backgroundImage: backgroundImage,
            backgroundImageMobile: backgroundImageMobile,
            className: className
        }, String(idx));
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs("section", {
        children: [
            blockTitle,
            blockDescription,
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_prezzee_ribbon_src_components_personal_StatsTile_StatsTileBlock_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
                children: tiles
            })
        ],
        className: section
    });
}
var make = StatsTilesSection;
 /* section Not a pure module */ 


/***/ }),

/***/ 52659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports UniqueSellingPoints, TextContainer, Tagline, Heading, Description, List, ListItem, ImageContainer, RichText, KontentContextConsumer, Styles, SideImage, Content */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20859);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(92592);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34442);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96533);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72721);
/* harmony import */ var _prezzee_ribbon_src_components_common_Tagline_Tagline_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1552);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75153);
/* harmony import */ var _prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_List_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15536);
/* harmony import */ var _prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_Heading_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93000);
/* harmony import */ var _prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_ListItem_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5495);
/* harmony import */ var _prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_Description_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18868);
/* harmony import */ var _prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_TextContainer_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68243);
/* harmony import */ var _prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_ImageContainer_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20910);
// Generated by ReScript, PLEASE EDIT WITH CARE



















var section = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_16__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .desktop */ .gv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(7.5)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(8.4375)),
            tl: /* [] */ 0
        }
    }),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .tablet */ .Mq, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(3)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(8.875)),
                tl: /* [] */ 0
            }
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .mobile */ .ai, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(3.6875)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(4.6875)),
                    tl: /* [] */ 0
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var Styles = {
    section: section
};
function UniqueSellingPointsSection$SideImage(props) {
    var backgroundImage = props.backgroundImage;
    if (backgroundImage !== undefined) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
            src: backgroundImage.url,
            alt: backgroundImage.description,
            width: backgroundImage.width,
            height: backgroundImage.height,
            sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .tabletSm */ .FV + " 100vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .tabletOrMobile */ .k$ + " 48vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .belowLargeScreen */ .Qo + " 44vw, 544px"
        });
    } else {
        return null;
    }
}
var SideImage = {
    make: UniqueSellingPointsSection$SideImage
};
function getUniqueSellingPointItems(items) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_17__/* .mapWithIndex */ .Su(items, function(idx, item) {
        var key = String(idx);
        var match = item.smartLink;
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_ListItem_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
                        children: item.title
                    })
                })
            }),
            itemId: match.itemId,
            elementCodename: match.codename
        }, key);
    });
}
var Content = {
    getUniqueSellingPointItems: getUniqueSellingPointItems
};
function UniqueSellingPointsSection(props) {
    var block = props.block;
    var heading = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("h2", {
        children: block.title
    });
    var description = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_7__.make, {
        children: block.description
    });
    var image = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(UniqueSellingPointsSection$SideImage, {
        backgroundImage: block.background_image
    });
    var uniqueSellingPointItems = getUniqueSellingPointItems(block.unique_selling_points);
    var match = block.smartLink;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("section", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs(_prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .Sy, {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs(_prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_TextContainer_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .S, {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_Tagline_Tagline_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S, {
                                    children: block.tagline
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_Heading_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .S, {
                                    children: heading
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_Description_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .S, {
                                    children: description
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_List_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .Sy, {
                                    children: uniqueSellingPointItems
                                })
                            ]
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_UniqueSellingPoints_UniqueSellingPoints_ImageContainer_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .make */ .S, {
                            children: image
                        })
                    ]
                })
            }),
            itemId: match.itemId,
            elementCodename: match.codename
        }),
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_18__/* .make */ .S([
            _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .section */ .qi,
            section
        ])
    });
}
var UniqueSellingPoints;
var TextContainer;
var Tagline;
var Heading;
var Description;
var List;
var ListItem;
var ImageContainer;
var RichText;
var KontentContextConsumer;
var make = UniqueSellingPointsSection;
 /* section Not a pure module */ 


/***/ }),

/***/ 61201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports KontentContextConsumer, Background, MediaWrapper, SideImage, VideoContainer, VideoOverlay, Video, TextWrapper, Heading, Description, Styles */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(20859);
/* harmony import */ var _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91574);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(92592);
/* harmony import */ var _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(7618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34442);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(72491);
/* harmony import */ var _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51741);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72721);
/* harmony import */ var _prezzee_ribbon_src_components_common_Tagline_Tagline_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1552);
/* harmony import */ var _KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99956);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89834);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64797);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Video_bs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8113);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Heading_bs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(27484);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_MobileAwareVideo_bs_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84318);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_SideImage_bs_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(73130);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Background_bs_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7012);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Description_bs_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(32600);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_TextWrapper_bs_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(62874);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_MediaWrapper_bs_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(50715);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_VideoOverlay_bs_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(37680);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_VideoContainer_bs_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(60927);
// Generated by ReScript, PLEASE EDIT WITH CARE





























var container = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_25__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .desktop */ .gv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(8.4375)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(6.5625)),
            tl: /* [] */ 0
        }
    }),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tablet */ .Mq, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(4.125)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(4.5)),
                tl: /* [] */ 0
            }
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .tabletSm */ .FV, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(0.375)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(0.375)),
                    tl: /* [] */ 0
                }
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .mobile */ .ai, {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2.75)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(3.6875)),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var description = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_25__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("a", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .hex */ .$v1("1A65F0")),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textDecoration */ .QXS("underline"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .hover */ .MrM({
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .hex */ .$v1("1E54B7")),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .active */ .bBs({
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .hex */ .$v1("102C60")),
                        tl: /* [] */ 0
                    }),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .visited */ .Fv({
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .hex */ .$v1("787878")),
                            tl: /* [] */ 0
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }),
    tl: /* [] */ 0
});
var Styles = {
    container: container,
    description: description
};
function VideoTextPromoSection(props) {
    var block = props.block;
    var match = react__WEBPACK_IMPORTED_MODULE_2__.useReducer(function(x, param) {
        return x + 1 | 0;
    }, 0);
    var smartLink = block.smartLink;
    var elementCodename = smartLink.codename;
    var itemId = smartLink.itemId;
    var side_image = block.side_image;
    var video_poster = block.video_poster;
    var mobile_video = block.mobile_video;
    var video = block.video;
    var forceUpdate = match[1];
    var taglineStr = block.tagline;
    var heading = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("h2", {
        children: block.title
    });
    var description$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_10__.make, {
        children: block.description
    });
    var videoUrl = video !== undefined ? video : "";
    var mobileUrl = mobile_video !== undefined ? mobile_video : "";
    var videoImageFallback;
    if (video_poster !== undefined) {
        var smartLink$1 = video_poster.smartLink;
        videoImageFallback = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                    src: video_poster.url,
                    alt: video_poster.description,
                    width: video_poster.width,
                    height: video_poster.height,
                    sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .mobile */ .ai + " 170px, 220px"
                })
            }),
            itemId: smartLink$1.itemId,
            elementCodename: smartLink$1.codename
        });
    } else {
        videoImageFallback = null;
    }
    var sideImage;
    if (side_image !== undefined) {
        var smartLink$2 = side_image.smartLink;
        sideImage = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_SideImage_bs_js__WEBPACK_IMPORTED_MODULE_18__/* .make */ .Sy, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                    src: side_image.url,
                    alt: side_image.description,
                    width: side_image.width,
                    height: side_image.height,
                    sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .mobile */ .ai + " 50vw, $(tabletOrMobile) 230px, 366px"
                })
            }),
            itemId: smartLink$2.itemId,
            elementCodename: smartLink$2.codename
        });
    } else {
        sideImage = null;
    }
    var validDesktopUrl = _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_26__/* .vimeoRegex.test */ .pE.test(videoUrl);
    var validMobileUrl = _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_26__/* .vimeoRegex.test */ .pE.test(mobileUrl);
    var invalidMsg = "is not a valid vimeo url.";
    if (!validDesktopUrl && _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_27__/* .isSome */ .pC(video)) {
        _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info({
            type: "Video Text Promo Section Desktop Video Url"
        }, 'info: "' + videoUrl + '" ' + invalidMsg + "");
    }
    if (!validMobileUrl && _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_27__/* .isSome */ .pC(mobile_video)) {
        _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info({
            type: "Video Text Promo Section Mobile Video Url"
        }, 'info: "' + mobileUrl + '" ' + invalidMsg + "");
    }
    var playerOptions = _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Player.options */ .J.options(undefined, true, undefined, undefined, undefined, false, undefined, block.loop_video, true, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined);
    var player = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .Sy, {
        id: "video-text-promo-player",
        playerOptions: playerOptions
    });
    var desktopVideo = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
        videoUrl: videoUrl,
        children: player
    });
    var mobileVideo = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_MobileAwareVideo_bs_js__WEBPACK_IMPORTED_MODULE_17__/* .make */ .S, {
        videoUrl: videoUrl,
        mobileUrl: mobileUrl,
        children: player
    });
    var video$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            validDesktopUrl && validMobileUrl ? mobileVideo : validDesktopUrl ? desktopVideo : null,
            videoImageFallback
        ]
    }, match[0].toString());
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_25__._1(forceUpdate, undefined);
    }, []);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("section", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .Sy, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Background_bs_js__WEBPACK_IMPORTED_MODULE_19__/* .make */ .S, {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_MediaWrapper_bs_js__WEBPACK_IMPORTED_MODULE_22__/* .make */ .Sy, {
                        children: [
                            sideImage,
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_VideoContainer_bs_js__WEBPACK_IMPORTED_MODULE_24__/* .make */ .S, {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_VideoOverlay_bs_js__WEBPACK_IMPORTED_MODULE_23__/* .make */ .S, {
                                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("img", {
                                                alt: "Phone frame",
                                                src: "/images/videoTextPromoSection/phone_overlay.png"
                                            })
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Video_bs_js__WEBPACK_IMPORTED_MODULE_15__/* .make */ .S, {
                                            children: video$1
                                        })
                                    ]
                                }),
                                itemId: itemId,
                                elementCodename: elementCodename
                            })
                        ]
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_TextWrapper_bs_js__WEBPACK_IMPORTED_MODULE_21__/* .make */ .S, {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_common_Tagline_Tagline_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
                                    children: taglineStr
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Heading_bs_js__WEBPACK_IMPORTED_MODULE_16__/* .make */ .S, {
                                    children: heading
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Description_bs_js__WEBPACK_IMPORTED_MODULE_20__/* .make */ .S, {
                                    children: description$1,
                                    className: description
                                })
                            ]
                        }),
                        itemId: itemId,
                        elementCodename: elementCodename
                    })
                ]
            })
        }),
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_28__/* .make */ .S([
            _IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .section */ .qi,
            container
        ])
    });
}
var KontentContextConsumer;
var Background;
var MediaWrapper;
var SideImage;
var VideoContainer;
var VideoOverlay;
var Video;
var TextWrapper;
var Heading;
var Description;
var make = VideoTextPromoSection;
 /* container Not a pure module */ 


/***/ })

}]);